export const atalhosLaudo = {
  'ctrl+alt+o': { nome: 'FECHAR', indice: '0' },
  'ctrl+alt+p': { nome: 'LAUDAR PENDENTE', indice: '1' },
  'ctrl+alt+n': { nome: 'CANCELAR', indice: '2' },
  'ctrl+alt+n': { nome: 'CANCELAR', indice: '2' },
  'ctrl+alt+l': { nome: 'LAUDAR', indice: '3' },
  'ctrl+alt+a': { nome: 'AUTO TEXTO', indice: '4' },
  'ctrl+alt+f': { nome: 'LISTA FRASCO', indice: '5' },
  'ctrl+alt+t': { nome: 'LAUDOS ANTERIORES', indice: '6' },
  'ctrl+alt+h': { nome: 'HISTORICO LAUDO', indice: '7' },
  'ctrl+alt+x': { nome: 'ANEXO', indice: '8' },
  'ctrl+alt+m': { nome: 'MULTIPLO EXAME', indice: '9' },
  'ctrl+alt+i': { nome: 'Informes clínicos', indice: '10' },
};



// WEBPACK FOOTER //
// ./src/app/common/common.const.js